import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import {
  selectJBPSettings,
  selectKiBusinessPriorities,
} from 'legacy/lut/features/partner360/jbpSettings'
import { createSelector } from 'reselect'

import { DEFAULT_CURRENCY, getCockpitInitiativesPlanQuality } from '../../lib'

import { selectCockpitCategory } from './selectCockpitCategory'
import { selectCockpitCurrency } from './selectCockpitCurrency'
import { selectCockpitGeoMappingItems } from './selectCockpitGeoMappingItems'
import { selectCockpitInitiativesPlanQualityByOffering } from './selectCockpitInitiativesPlanQualityByOffering'
import { selectCockpitMetric } from './selectCockpitMetric'
import { selectCockpitOffering } from './selectCockpitOffering'
import { selectCockpitPeriods } from './selectCockpitPeriods'
import { selectCockpitPlanningPeriod } from './selectCockpitPlanningPeriod'
import { selectEffectiveCockpitActualsSync } from './selectEffectiveCockpitActualsSync'
import { selectVisibleCockpitFinSobRows } from './selectVisibleCockpitFinSobRows'
import { selectVisibleCockpitKeyInitiatives } from './selectVisibleCockpitKeyInitiatives'
import { selectVisibleCockpitPartnerData } from './selectVisibleCockpitPartnerData'

export const selectCockpitInitiativesPlanQualitySummary = createSelector(
  [
    selectCockpitInitiativesPlanQualityByOffering,
    selectCockpitOffering,
    selectCockpitCategory,
    selectVisibleCockpitKeyInitiatives,
    selectVisibleCockpitFinSobRows,
    selectVisibleCockpitPartnerData,
    selectCockpitGeoMappingItems,
    selectKiBusinessPriorities,
    selectJBPSettings,
    selectEffectiveCockpitActualsSync,
    selectCockpitMetric,
    selectCockpitCurrency,
    selectCockpitPeriods,
    selectCockpitPlanningPeriod,
  ],
  (
    qualityByOffering,
    selectedOffering,
    selectedCategory,
    initiatives,
    rows,
    partners,
    geoMappingItems,
    businessPriorities,
    { keyObjectives },
    { fYear, currentFQuarter, fQuarterActualsPercentage },
    selectedMetric,
    selectedCurrency,
    selectedPeriods,
    planningPeriod
  ) => {
    const selectedOfferingQuality = qualityByOffering.byOffering.get(selectedOffering)

    if (!selectedCategory || selectedOffering === ProgramTypes.Overall) {
      return {
        ...qualityByOffering,
        selectedQuality:
          selectedOffering === ProgramTypes.Overall
            ? qualityByOffering.overallQuality
            : (selectedOfferingQuality ?? null),
      }
    }

    const selectedQuality = getCockpitInitiativesPlanQuality({
      initiatives,
      rows,
      partners,
      geoMappingItems,
      businessPriorities,
      keyObjectives,
      offering: selectedOffering,
      fYear,
      currentFQuarter,
      fQuarterActualsPercentage,
      selectedMetric,
      selectedCurrency,
      selectedPeriods,
      planningPeriod,
      isLocalCurrency: selectedCurrency !== DEFAULT_CURRENCY,
      selectedCategory,
    })

    return { ...qualityByOffering, selectedQuality }
  }
)
